import { VISIBILITIES } from '../../constants';
import Url from '../Url';

interface AllProps {
  location?: any;
  locationCategory?: any;
  lobbyAvailability?: boolean;
  method?: number | string;
  region?: any;
  service?: any;
  settings?: {
    invite_only_resources?: boolean;
    preferred_location?: any;
  };
  user?: any;
  userCategory?: any;
  visibility?: number;
}

const SupportedLanguages = (client) => ({
  all({
    location,
    locationCategory,
    lobbyAvailability = false,
    method,
    region,
    service,
    settings,
    user,
    userCategory,
    visibility = VISIBILITIES.PUBLIC,
  }: AllProps): Promise<any> {
    const filters: Record<string, any> = {};

    if (location) {
      filters.location = location.id;
    }

    if (locationCategory && !settings?.preferred_location) {
      filters.location_category = locationCategory.id;
    }

    if (method) {
      filters.meeting_method = method;
    }

    if (region) {
      filters.region = region;
    }

    if (service) {
      filters.service = service.id;
    }

    if (user) {
      filters.user = user.id;
    }

    if (userCategory) {
      filters.user_category = userCategory.id;
    }

    if (visibility !== undefined) {
      filters.visibility = visibility;
    }

    if (settings?.invite_only_resources) {
      filters.invite_only_resources = settings.invite_only_resources;
    }

    if (lobbyAvailability) {
      filters.lobby_availability = lobbyAvailability;
    }

    return client.get(Url.url('/api/v2/open/supported-languages', filters));
  },
});

export default SupportedLanguages;
